// The events that the machine handles
export enum VaultModalEvent {
  OPEN_LIQUIDITY_MODAL = 'OPEN_LIQUIDITY_MODAL',
  CLOSE_LIQUIDITY_MODAL = 'CLOSE_LIQUIDITY_MODAL',
  OPEN_DEPOSIT_MODAL = 'OPEN_DEPOSIT_MODAL',
  CLOSE_DEPOSIT_MODAL = 'CLOSE_DEPOSIT_MODAL',
  OPEN_WITHDRAW_MODAL = 'OPEN_WITHDRAW_MODAL',
  CLOSE_WITHDRAW_MODAL = 'CLOSE_WITHDRAW_MODAL',
}

